import { useEffect, useState } from "react";
import React from "react";
import {
  Col,
  Container,
  Row,
  Input,
  Button,
  Card,
  CardBody,
  Table,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import avatar from "../../../assets/images/personPlaceholder.png";
import check from "../../../assets/images/check.svg";
import moreIcon from "../../../assets/images/more.png";
import { get, del, put } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import { toast, Bounce } from "react-toastify";
import find from "../../../assets/find.svg";
import { useSelector } from "react-redux";
import Placeholder from "../../../assets/images/Placeholder.gif";

const GymRatings = () => {
  document.title = "Gym Ratings | Elevated - Admin Dashboard";
  const [dropdownOpen, setDropdownOpen] = useState({});
  const [equipData, setEquipData] = useState([]); // Initialize as empty array
  const [loading, setLoading] = useState(true);
  const [userRoles, setUserRoles] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState("");
  const [itemPerPage, setItemPerPage] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const itemsPerPage = 6;
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const gymId = searchParams.get("gymId");
  const { userPermissions, appRole, id } = useSelector(
    (state) => state.auth.currentUser
  );

  useEffect(() => {
    const handler = setTimeout(() => setDebouncedSearchTerm(searchTerm), 300);
    return () => clearTimeout(handler);
  }, [searchTerm]);

  const fetchEquip = async (page = 1, searchQuery = "") => {
    setLoading(true);
    try {
      const response = await get(
        `${endpoints.gymAllRatings}?limit=${6}&page=${page}`
      );
      const data = response?.data?.data || []; // Ensure data is an array
      setEquipData(data);

      setTotalPages(response.data?.totalPages || 1);
      setItemPerPage(response.data?.data?.length || 0);
      setTotalItems(response.data?.totalCount || 0);
    } catch (error) {
      console.error("Error fetching equipment data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEquip(currentPage);
  }, [currentPage]);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  return (
    <div className="">
      <Container fluid>
        <Row>
          <Col>
            <Card className="rounded-4">
              <CardBody>
                <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center mb-3">
                  <div className="d-flex flex-row justify-content-start align-items-center gap-2 w-100 mt-2 mt-sm-0">
                    <span className="font-size-20 fw-bold primary-black ff-sora mb-2 mb-sm-0 d-md-block">
                      Gym Ratings
                    </span>
                  </div>
                </div>

                <>
                  <div
                    className="table-responsive hide-scrollbar rounded-4"
                    style={{
                      height: equipData?.length > 0 ? "500px" : "auto",
                    }}
                  >
                    <Table
                      hover
                      className="table-borderless table-centered table-nowrap ff-sora"
                    >
                      <thead>
                        <tr>
                          <th>Id</th>
                          <th>Gym Name</th>
                          <th>Rating</th>
                          <th>Organization & Cleanliness</th>
                          <th>Vibe & Uniqueness</th>
                          <th>Equipment Curation</th>
                          <th>Accessibility & Crowd Size</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan={8} className="text-center">
                              <div className="d-flex justify-content-center align-items-center">
                                <div
                                  className="spinner-border"
                                  style={{
                                    width: "3rem",
                                    height: "3rem",
                                    color: "#3BABA6",
                                  }}
                                  role="status"
                                >
                                  <span className="visually-hidden">
                                    Loading...
                                  </span>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ) : equipData.length === 0 ? (
                          <></>
                        ) : (
                          Array.isArray(equipData) &&
                          equipData?.map((equip, index) => (
                            <tr
                              key={index}
                              onClick={() =>
                                navigate(
                                  `/individual-gym-ratings?gymId=${equip?._id}`
                                )
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <td className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                                {(currentPage - 1) * itemsPerPage + index + 1}
                              </td>
                              <td className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                                {equip?.gymName ? equip?.gymName : "0"}
                              </td>
                              <td className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                                {equip?.ratings?.length
                                  ? `${(
                                      (equip?.totalGeneralExperience +
                                        equip?.totalService +
                                        equip?.totalFacilityQuality +
                                        equip?.totalAccessibilityConvenience) /
                                      (equip?.ratings?.length * 4)
                                    ).toFixed(1)} (${equip?.ratings?.length})`
                                  : "0"}
                              </td>

                              <td className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                                {equip?.totalGeneralExperience
                                  ? parseFloat(
                                      equip.totalGeneralExperience /
                                        equip.ratings.length
                                    ).toFixed(1)
                                  : "0"}
                              </td>
                              <td className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                                {equip?.totalService
                                  ? parseFloat(
                                      equip.totalService / equip.ratings.length
                                    ).toFixed(1)
                                  : "0"}
                              </td>
                              <td className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                                {equip?.totalFacilityQuality
                                  ? parseFloat(
                                      equip?.totalFacilityQuality /
                                        equip.ratings.length
                                    ).toFixed(1)
                                  : "0"}
                              </td>
                              <td className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                                {equip?.totalAccessibilityConvenience
                                  ? parseFloat(
                                      equip.totalAccessibilityConvenience /
                                        equip.ratings.length
                                    ).toFixed(1)
                                  : "0"}
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </Table>
                    {!loading && equipData.length === 0 && (
                      <div className="d-flex flex-column align-items-center justify-content-center vh-50">
                        <img
                          src={Placeholder}
                          alt="No record placeholder"
                          className="object-fit-contain img-fluid h-25 w-25 rounded-3 mb-3"
                        />
                        <p className="mt-3 ff-sora font-size-16 fw-normal">
                          No Record Found!
                        </p>
                      </div>
                    )}
                  </div>
                </>
              </CardBody>
            </Card>

            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                height: "40px",
                position: "sticky",
                bottom: "0",
                zIndex: "10",
                backgroundColor: "#f5f5f5",
              }}
            >
              <div>
                <span className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                  {`Showing ${Math.min(
                    (currentPage - 1) * itemsPerPage + itemPerPage
                  )} of ${totalItems}`}
                </span>
              </div>
              <div className="d-flex justify-content-center">
                <Button
                  style={{
                    width: "40px",
                    height: "40px",
                    color: "#1f1f1f",
                    borderWidth: "1px",
                    borderColor: currentPage === 1 ? "#f5f5f5" : "#1f1f1f",
                    background: "#f5f5f5",
                    borderRadius: "80px",
                  }}
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  &lt;
                </Button>
                {[...Array(totalPages).keys()]
                  .slice(
                    Math.max(0, currentPage - 2),
                    Math.min(totalPages, currentPage + 1)
                  )
                  .map((page) => (
                    <Button
                      key={page + 1}
                      onClick={() => handlePageChange(page + 1)}
                      style={{
                        width: "40px",
                        height: "40px",
                        color: currentPage === page + 1 ? "white" : "#1f1f1f",
                        background:
                          currentPage === page + 1 ? "#3BABA6" : "#f5f5f5",
                        marginLeft: "10px",
                        marginRight: "10px",
                        borderRadius: "80px",
                        border: 0,
                      }}
                      className={currentPage === page + 1 ? "active" : ""}
                    >
                      {page + 1}
                    </Button>
                  ))}
                <Button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  style={{
                    width: "40px",
                    height: "40px",
                    color: "#1f1f1f",
                    borderWidth: "1px",
                    borderColor:
                      currentPage === totalPages ? "#f5f5f5" : "#1f1f1f",
                    background: "#f5f5f5",
                    borderRadius: "80px",
                  }}
                >
                  &gt;
                </Button>
              </div>
            </div>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                height: "60px",
                position: "sticky",
                bottom: "0",
                zIndex: "10",
              }}
            ></div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default GymRatings;
